import {r} from "@/utils/responsive";
import React from "react";
import buttonMainGlow from "@/assets/img/button_main_glow.png";

interface ButtonMainProps extends React.HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode;
    width?: number;
    height?: number;
    glowImage?: string;
    glowTop?: number;
    glowWidth?: number;
    glowHeight?: number;
    onClick?: () => void;
}

const ButtonMain: React.FC<ButtonMainProps> = ({
                                                   className,
                                                   children,
                                                   width = 952,
                                                   height = 140,
                                                   glowImage = buttonMainGlow,
                                                   glowTop = -29,
                                                   glowWidth = 1024,
                                                   glowHeight = 218,
                                                   onClick,
                                                   ...props
                                               }) => {
    const finalWidth = r.vmax(width);
    const finalHeight = r.vmax(height);

    return (
        <div
            {...props}
            style={{
                width: finalWidth,
                height: finalHeight,
                position: 'relative'
            }}
        >
            <button
                onClick={onClick}
                style={{
                    position: "absolute",
                    inset: 0,
                    zIndex: 1,
                    display: "flex",
                    gap: `max(${r.vmax(12)}, 12px)`,
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                {children}
            </button>
            <div
                style={{
                    position: "absolute",
                    top: r.vmax(glowTop),
                    left: "50%",
                    transform: "translateX(-50%)",
                    pointerEvents: "none",
                    width: r.vmax(glowWidth),
                    height: r.vmax(glowHeight),
                    userSelect: "none",
                }}
            >
                <img
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: 'contain',
                        objectPosition: "50% 50%",
                    }}
                    src={glowImage}
                    alt="Button Main Glow"
                />
            </div>
        </div>
    );
};

export default ButtonMain;
